import React, { Dispatch } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addFollower } from "api/requests/addFollower";
import { SnackBarMessages, useSnackBar } from "context/SnackBarContext";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { DISPENSARY_FOLLOW } from "redux/reducers/dispensary";
import { AllActions } from "redux/reducers/rootReducer";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { Action, Category, trackEvent } from "utils/trackEvent";

import Button from "components/botanic/Button";
import { Modal } from "components/botanic/Modal";
import TrackImpression from "components/TrackImpression";

const ReviewConfirmationModal = ({
  ssoDispensaryRedirect,
  ssoMenuRedirect,
  favorite = false,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
any) => {
  const { id } = useSelector(getCurrentDispensary) || {};
  const dispatch = useDispatch<Dispatch<AllActions>>();
  const { addSnackBarItem } = useSnackBar();
  const countryCode = useDomainCountryCode();

  const handleFollow = async () => {
    const addFollowerSuccess = await addFollower({
      countryCode,
      followeeId: id,
      followeeType: "dispensary",
    });

    trackEvent(
      Category.dispensaryFavorite,
      Action.click,
      `favorite dispensary review`
    );

    if (addFollowerSuccess) {
      dispatch({
        type: DISPENSARY_FOLLOW,
      });

      await ssoDispensaryRedirect();

      addSnackBarItem(SnackBarMessages.dispensaryAdded);
    }
  };

  const continueShopping = async () => {
    trackEvent(Category.dispensaryShop, Action.click, `dispensary review`);

    await ssoMenuRedirect();
    addSnackBarItem(SnackBarMessages.dispensaryReviewSubmitted);
  };

  return (
    <Modal
      onDismissed={ssoDispensaryRedirect}
      aria-labelledby="review-confirmation-modal-title"
      width={560}
      mobileFullscreen={false}
    >
      {favorite && (
        <TrackImpression
          category="Reviews"
          action="impression"
          label="Favorite CTA"
        >
          <div className="text-default text-center pt-md md:p-lg">
            <h3
              className="text-md font-xbold mb-md"
              id="review-confirmation-modal-title"
            >
              Thank you!
            </h3>
            <p className="text-center px-md">
              Your review is pending approval. In the meantime,
              <span className="mx-xs" role="img" aria-label="heart">
                💚️
              </span>
              this dispensary for updates and special offers.
            </p>
            <div>
              <Button
                className="px-xxl mt-xl md:mt-xxl text-sm"
                role="button"
                width="full"
                onClick={handleFollow}
              >
                heart this dispensary
              </Button>
            </div>
          </div>
        </TrackImpression>
      )}
      {!favorite && (
        <TrackImpression
          category="Reviews"
          action="impression"
          label="Shop CTA"
        >
          <div className="text-default text-center pt-md md:p-lg">
            <h3
              className="text-md font-xbold mb-md"
              id="review-confirmation-modal-title"
            >
              Thank you!
            </h3>
            <p className="text-center px-md">
              Your review is pending approval. In the meantime, enjoy the
              products this dispensary has to offer.
            </p>
            <div>
              <Button
                className="px-xxl mt-xl md:mt-xxl text-sm"
                role="button"
                width="full"
                onClick={continueShopping}
              >
                shop this dispensary
              </Button>
            </div>
          </div>
        </TrackImpression>
      )}
    </Modal>
  );
};

export default ReviewConfirmationModal;
